const hospitalsData = [
  {
    "id": "fortis-thailand-1752917187757",
    "uniqueId": "fortis-thailand-thailand-1752917187757",
    "country": "Thailand",
    "name": "Fortis Thailand",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752917181/medical-linkers/doctors/xhwzgee8chrpqx5cnfuf.jpg",
    "description": "rb4h4ncuhrchr",
    "about": "rucrhucfhrcr crucurhcurdc rjncbruchnru",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752917187/medical-linkers/doctors/sfbgjmn0h8cwfqnbiluv.jpg"
    ],
    "specialities": [
      "Cardiac Sciences",
      "Neurology",
      "ENT (Ear, Nose, Throat)"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752917183/medical-linkers/doctors/vqoenb8rbf8wjeqq1fbm.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752917185/medical-linkers/doctors/beqxeqiwvet92kmybxcn.jpg"
    ],
    "amenities": [
      "evv"
    ],
    "treatments": [
      "rge"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-thailand-1752915803820",
    "uniqueId": "fortis-thailand-thailand-1752915803820",
    "country": "Thailand",
    "name": "Fortis Thailand",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752915799/medical-linkers/doctors/af6eyynlk9iusxbaytga.jpg",
    "description": "ebvyfciwdwnivrbfu3ievhu",
    "about": "eyvsuycveygcegydbegfyegf7ue",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752915804/medical-linkers/doctors/acbqvxnotf4jes7ruwcj.jpg"
    ],
    "specialities": [
      "Pediatrics",
      "Pathology",
      "Vascular Surgery"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752915802/medical-linkers/doctors/zsuyhoevyfjyqpe297j3.jpg"
    ],
    "amenities": [
      "evv"
    ],
    "treatments": [
      "rge"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "apollo-delhi-1752911329186",
    "uniqueId": "apollo-delhi-south korea-1752911329186",
    "country": "South Korea",
    "name": "Apollo Delhi",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752911312/medical-linkers/doctors/d7r3wxhlrwuqubcibkxk.jpg",
    "description": "2w3 evebfuefhienciebejvbevjbjv e",
    "about": "ln bdcve cecuhenscbues be bueuecunucuevebbvb",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752911328/medical-linkers/doctors/g9aj72bacj9jr5cgrxlw.jpg"
    ],
    "specialities": [
      "Pathology",
      "Cardiac Surgery",
      "NICU",
      "Radiology"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752911316/medical-linkers/doctors/pnbjw81010i0sallysqq.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752911318/medical-linkers/doctors/xlnmpu38jxgi3ue7i98w.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752911320/medical-linkers/doctors/kxitelxyyfkzx2wmrbl2.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752911324/medical-linkers/doctors/trm6cfvmqmwrl1ywtdem.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752911325/medical-linkers/doctors/qifrwirqsw43nvkysghy.jpg"
    ],
    "amenities": [
      "Hostel",
      "Food Court",
      "Labs",
      "Parking"
    ],
    "treatments": [
      "OPD, cancer"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "apollo-korea-1752871159015",
    "uniqueId": "apollo-korea-south korea-1752871159017",
    "country": "South Korea",
    "name": "Apollo Korea",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752871146/medical-linkers/doctors/tsgrlg9kgbmm8eiqpxxq.jpg",
    "description": "nncrncrncur",
    "about": "rbhchecbrunucr",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752871157/medical-linkers/doctors/yee1wqsrykpu2m22lyqn.jpg"
    ],
    "specialities": [
      "Neurology",
      "Psychiatry",
      "Robotic Surgery"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752871149/medical-linkers/doctors/oe4limvaznb2e9rw2qgw.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752871150/medical-linkers/doctors/nxrokctsxi2go1dkxoxd.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752871152/medical-linkers/doctors/aldp56gd7ur97g9kg39o.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752871154/medical-linkers/doctors/mmemxnhybzf8fm4r1y0c.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752871156/medical-linkers/doctors/qt2z7cbzlqe7j9mir7mr.jpg"
    ],
    "amenities": [
      "Food and mess"
    ],
    "treatments": [
      "hbwuxnuan"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-korea-1752865955548",
    "uniqueId": "fortis-korea-south korea-1752865955548",
    "country": "South Korea",
    "name": "Fortis Korea",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752865937/medical-linkers/doctors/fkejnycnxksgcwfg4qvv.jpg",
    "description": "tyumtrebecwxcevtbynui,imunbt",
    "about": ".o,imunbtvrvtyum7i8,oimntrefvtynumi,o",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752865953/medical-linkers/doctors/smbxadoaedxfhkfqhu9l.jpg"
    ],
    "specialities": [
      "Cardiac Sciences",
      "Neurology",
      "ENT (Ear, Nose, Throat)"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752865939/medical-linkers/doctors/lgfahdwhlixesmsnyh1g.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752865942/medical-linkers/doctors/unzgyb9pcqtfcl5pxgur.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752865944/medical-linkers/doctors/x6jys9puywzupyfsd92d.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752865948/medical-linkers/doctors/gcxoxrsutsjs6azpiqo6.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752865951/medical-linkers/doctors/yoibpqaj6byket84yoep.jpg"
    ],
    "amenities": [
      "mess"
    ],
    "treatments": [
      "very good"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "cohortlab-1752844247905",
    "uniqueId": "cohortlab-india-1752844247905",
    "country": "India",
    "name": "CohortLab",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752844233/medical-linkers/doctors/vfd8m5dllnymyvca7qdy.jpg",
    "description": "beiybvhejc",
    "about": " cbheyvcuikne",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752844245/medical-linkers/doctors/bdpopltoivjwfxagdtvj.jpg"
    ],
    "specialities": [
      "Pediatrics",
      "Pathology",
      "Cardiac Surgery"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752844235/medical-linkers/doctors/zvrsnfanimirmrdmifdt.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752844237/medical-linkers/doctors/svlkdjfpomxvz43ueeeb.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752844239/medical-linkers/doctors/qoyyiawimvpu3w0rjjbe.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752844241/medical-linkers/doctors/jkgteqydtnl6yetqb9pr.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752844243/medical-linkers/doctors/sutnh45l7lxvaeq1ie0o.jpg"
    ],
    "amenities": [
      "mss"
    ],
    "treatments": [],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-bund-1752741908141",
    "uniqueId": "fortis-bund-turkey-1752741908141",
    "country": "Turkey",
    "name": "FOrtis Bund",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752741895/medical-linkers/doctors/z34ztxay5v1qvolucrqh.jpg",
    "description": "neunv",
    "about": "nuncuneuue",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752741906/medical-linkers/doctors/lf9liohml41aj3f4lla6.jpg"
    ],
    "specialities": [
      "ENT (Ear, Nose, Throat)",
      "Pathology",
      "Neurosurgery"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752741898/medical-linkers/doctors/kh85kxnbg33il6icpn83.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752741899/medical-linkers/doctors/tmf0vm5wmuuhocmugcxi.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752741901/medical-linkers/doctors/hininyod2gydsvzshwkm.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752741903/medical-linkers/doctors/dsuviaoclrgrv6y4o9ip.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752741905/medical-linkers/doctors/hszkjb8eedsluuiymb2p.jpg"
    ],
    "amenities": [
      " j4ncec"
    ],
    "treatments": [
      " jnce"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-noida-1752738333611",
    "uniqueId": "fortis-noida-india-1752738333611",
    "country": "India",
    "name": "Fortis Noida",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752738319/medical-linkers/doctors/evkzrpkxtr7cwc6w76wz.jpg",
    "description": "Very good hopital",
    "about": "Actuallly very goood",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752738331/medical-linkers/doctors/xrpbehyks6g3xtci6pzh.jpg"
    ],
    "specialities": [],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752738321/medical-linkers/doctors/ilg1ikfakp5dn303gsou.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752738324/medical-linkers/doctors/qju1wfibifczymhnlhfh.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752738325/medical-linkers/doctors/z6pr161miy1euildypzw.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752738328/medical-linkers/doctors/tm7xcrzvdp7emzb4pqvy.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752738330/medical-linkers/doctors/jott0n2rgesfoml4sspi.jpg"
    ],
    "amenities": [
      "jnnkcwm"
    ],
    "treatments": [
      "nwjncwjw"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-goa-1752737815367",
    "uniqueId": "fortis-goa-india-1752737815368",
    "country": "India",
    "name": "Fortis Goa",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752737802/medical-linkers/doctors/kku09g2hx5cu2aoivdvf.jpg",
    "description": "I am a good boy",
    "about": "I am a good buy",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752737813/medical-linkers/doctors/drcrogq7axpmo1yr6uzy.jpg"
    ],
    "specialities": [],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752737804/medical-linkers/doctors/zmgv2rxflkswocb4i41d.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752737806/medical-linkers/doctors/o7wec4nzfqj4gcobcki9.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752737807/medical-linkers/doctors/gry7bsvtu0vghuhyinne.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752737810/medical-linkers/doctors/v3erovtcbk43kvtbams5.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752737812/medical-linkers/doctors/invljzsalngfwvvqv1ff.jpg"
    ],
    "amenities": [
      "Mess"
    ],
    "treatments": [
      "Everything"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-abu-dhabi-1752734396906",
    "uniqueId": "fortis-abu-dhabi-india-1752734396906",
    "country": "India",
    "name": "Fortis Abu Dhabi",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752734385/medical-linkers/doctors/tgplabkrl9mkpmua1l2n.jpg",
    "description": "https://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxx",
    "about": "https://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxx",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752734395/medical-linkers/doctors/d9qycmahqcsfr8ufdaul.jpg"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752734387/medical-linkers/doctors/p2bl3ca8yfdto0i9eeye.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752734388/medical-linkers/doctors/j6tltjnxc3wtx7ng10qx.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752734390/medical-linkers/doctors/t2ob5st17pcneoz3cwek.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752734392/medical-linkers/doctors/iuhzxl6kzghwox7e26qp.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752734394/medical-linkers/doctors/ptnqq1hhcg3j2gc5k0nm.jpg"
    ],
    "amenities": [
      "mes"
    ],
    "treatments": [
      "hsok"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-dubai-1752733973063",
    "uniqueId": "fortis-dubai-india-1752733973063",
    "country": "India",
    "name": "Fortis Dubai",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752733959/medical-linkers/doctors/bpl0hobnoc2thtdbtw3q.jpg",
    "description": "https://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-https://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxx://eet.google.com/aop-gvgf-oxx",
    "about": "https://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxxhttps://meet.google.com/aop-gvgf-oxx",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752733971/medical-linkers/doctors/gfqjuqrechmkqgnfsopz.jpg"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752733962/medical-linkers/doctors/ozgeloxbe7u37atkhlom.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752733965/medical-linkers/doctors/cehfssarpwerdvxduhdd.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752733966/medical-linkers/doctors/ooeyfxxxifl2p6ekaqbc.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752733968/medical-linkers/doctors/r7ckjdnzngz7459ss3pj.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752733969/medical-linkers/doctors/yk5lzmtgxtaahikwdprt.jpg"
    ],
    "amenities": [
      "Hose=tel",
      "Mess",
      "Labs",
      "Canteen"
    ],
    "treatments": [
      "Very Good Treatment"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-delhi-1752732478705",
    "uniqueId": "fortis-delhi-india-1752732478706",
    "country": "India",
    "name": "Fortis Delhi",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732448/medical-linkers/doctors/kavijdducomr8tytekj6.jpg",
    "description": "https://meet.google.com/aop-gvgf-oxx\nhttps://meet.google.com/aop-gvgf-oxx",
    "about": "https://meet.google.com/aop-gvgf-oxx\nhttps://meet.google.com/aop-gvgf-oxx\nhttps://meet.google.com/aop-gvgf-oxx\nhttps://meet.google.com/aop-gvgf-oxx",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732468/medical-linkers/doctors/jeg3n0artc2bzxn0dsne.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732473/medical-linkers/doctors/h0f9q6ayrnp4gcfdym3a.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732476/medical-linkers/doctors/bhl8c3ka7s2vexnagp9f.jpg"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732451/medical-linkers/doctors/syr27lboqcxug0dvzaar.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732455/medical-linkers/doctors/lqibuulak2qakpuab6yj.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732458/medical-linkers/doctors/scwbm51llfl9edmx4uwz.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732463/medical-linkers/doctors/sqpflfqeahrjmt8itygl.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752732464/medical-linkers/doctors/svjepgfxrwiprgkvru9m.jpg"
    ],
    "amenities": [
      "Mess",
      "Canteen",
      "Hostel"
    ],
    "treatments": [
      "Sab ho jaayega"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-bhubaneswar-1752688876129",
    "uniqueId": "fortis-bhubaneswar-india-1752688876129",
    "country": "India",
    "name": "Fortis Bhubaneswar",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752688858/medical-linkers/doctors/zz0xxgzjgqyl9gddr4wp.jpg",
    "description": "Good Morning INida",
    "about": "Good Mnbdejnj wbujwnf\nbwfjwnkn\nwjvncjw",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752688871/medical-linkers/doctors/njg9ndad7l6c4uao2gs5.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752688873/medical-linkers/doctors/wdy3aohexnojj1kr2zor.jpg"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752688860/medical-linkers/doctors/eu7djcpxuvnf4uep7pdh.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752688863/medical-linkers/doctors/vnsntuypv4rbn2ptltl1.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752688865/medical-linkers/doctors/md37kgywvmerdovuyoag.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752688868/medical-linkers/doctors/jzapql0368995jkiq5qm.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752688870/medical-linkers/doctors/zjw2phn9q6tyyvfjruln.jpg"
    ],
    "amenities": [
      "Mess",
      "Canteen"
    ],
    "treatments": [
      "Mess",
      "Canteen"
    ],
    "doctors": [],
    "similarHospitals": []
  },
  {
    "id": "fortis-jamshedpur-1752687857269",
    "uniqueId": "fortis-jamshedpur-india-1752687857269",
    "country": "India",
    "name": "FOrtis Jamshedpur",
    "mainImage": "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752687831/medical-linkers/doctors/dlsfa0upeiixtreyswbk.jpg",
    "description": "Goof Mornung Lads",
    "about": "Good morniing lads",
    "recognitions": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752687855/medical-linkers/doctors/xqskms1qd6eg16focgqk.jpg"
    ],
    "gallery": [
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752687836/medical-linkers/doctors/kr6unsypyg6ibwh0go9k.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752687841/medical-linkers/doctors/y38q48r1lpn4rucnk8jg.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752687845/medical-linkers/doctors/emevu2dijroaj6bimz5x.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752687849/medical-linkers/doctors/sxqezcp9pcznlju6ewop.jpg",
      "https://res.cloudinary.com/drpnp4uzc/image/upload/v1752687853/medical-linkers/doctors/yq4min3ps8raqqkpgeq0.jpg"
    ],
    "amenities": [
      "Lab"
    ],
    "treatments": [
      "Orthopaedics"
    ],
    "doctors": [],
    "similarHospitals": []
  }
];

export default hospitalsData;
